import React, { Component } from 'react';

import { Alert, Button, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

import UtilsService from '../../system/services/UtilsService';
import config from '../../config';

class ContactForm extends Component {

    constructor(props) {
        super(props);

        this.state = this.getDefaultState();
        this.utilsService = new UtilsService();
    }

    getEmailValidationState() {
        if ( ! this.state.emailDirty) return null;
        return this.isEmailValid() ? "success" : "error";
    }

    getDefaultState() {
        return {
            email: "",
            emailDirty: false,
            message: "",
            messageDirty: false,
            subject: "",
            subjectDirty: false,
            showError: false,
            showSuccess: false
        };
    }

    getMessageValidationState() {
        if ( ! this.state.messageDirty) return null;
        return this.isMessageValid() ? "success" : "error";
    }

    getSubjectValidationState() {
        if ( ! this.state.subjectDirty) return null;
        return this.isSubjectValid() ? "success" : "error";
    }

    handleBlur(event) {
        var obj = {};
        obj[event.target.id+"Dirty"] = true;
        this.setState(obj);
    }

    handleChange(event) {
        var obj = {};
        obj[event.target.id] = event.target.value;
        this.setState(obj);
    }

    isEmailValid() {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(this.state.email);
    }

    isFormDirty() {
        return (this.state.emailDirty || this.state.messageDirty || this.state.subjectDirty);
    }

    isFormValid() {
        return (this.getEmailValidationState()   === "success" &&
                this.getMessageValidationState() === "success" &&
                this.getSubjectValidationState() === "success");
    }

    isMessageValid() {
        return (this.state.message.length > 0);
    }

    isSubjectValid() {
        return (this.state.subject.length > 0);
    }

    submit(e) {
        e.preventDefault();

        // Set all form fields dirty
        this.setState({
            emailDirty: true,
            messageDirty: true,
            subjectDirty: true
        });

        if (this.isFormValid()) {
            window._paq.push(['trackEvent', 'Contact', 'Submit', 'Start'])

            this.utilsService.sendPlainEmail(
                "no-reply@troistudio.com",
                config.mailToAddress,
                this.state.email,
                this.state.subject,
                this.state.message
            ).done(function(data) {
                if (typeof this.props.onSuccessfulSubmit === "function") this.props.onSuccessfulSubmit(data);

                this.setState(this.getDefaultState());
                this.setState({
                    showSuccess: true,
                    showError: false
                });

                window._paq.push(['trackEvent', 'Contact', 'Submit', 'Success'])
            }.bind(this)).fail(function(data) {
                if (typeof this.props.onErrorSubmit === "function") this.props.onErrorSubmit(data);

                this.setState({
                    showSuccess: false,
                    showError: true
                });

                window._paq.push(['trackEvent', 'Contact', 'Submit', 'Failed'])
            }.bind(this));
        } else {
            this.setState({
                showSuccess: false,
                showError: true
            });
        }
    }

    renderSuccess() {
        if (this.state.showSuccess) {
            return (
                <Alert bsStyle="success">
                    Thanks! We'll be in touch!
                </Alert>
           );
        }
    }

    renderError() {
        if (this.state.showError) {
            return (
                <Alert bsStyle="danger">
                    Error while sending email, please try again
                </Alert>
           );
        }
    }

    render() {
        return (
            <form onSubmit={this.submit.bind(this)}>
                {this.renderSuccess()}
                {this.renderError()}

                <FormGroup controlId="email" validationState={this.getEmailValidationState()}>
                    <ControlLabel>Email</ControlLabel>
                    <FormControl type="email" value={this.state.email}
                        placeholder="Enter your email" onChange={this.handleChange.bind(this)}
                        onBlur={this.handleBlur.bind(this)} />
                    <FormControl.Feedback />
                </FormGroup>

                <FormGroup controlId="subject" validationState={this.getSubjectValidationState()}>
                    <ControlLabel>Subject</ControlLabel>
                    <FormControl type="text" value={this.state.subject}
                        placeholder="Enter your subject" onChange={this.handleChange.bind(this)}
                        onBlur={this.handleBlur.bind(this)} />
                    <FormControl.Feedback />
                </FormGroup>

                <FormGroup controlId="message" validationState={this.getMessageValidationState()}>
                    <ControlLabel>Message</ControlLabel>
                    <FormControl componentClass="textarea" value={this.state.message}
                        placeholder="Enter your message" onChange={this.handleChange.bind(this)}
                        onBlur={this.handleBlur.bind(this)} />
                    <FormControl.Feedback />
                </FormGroup>

                <Button type="submit" className="btn-primary">
                    Submit
                </Button>
            </form>
       );
    }

}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/contact/ContactForm.js